import axios from "axios";
import store from "@store";

// LIQ-2403: without a timeout axios waits forever, so a hung request left its panel spinning
// with no error. 110s: a genuine cold-cache load at full data volume can run past 60s (why the
// backend ingress allows 120s), and ending just before the ingress does means the user gets the
// page's own "took too long" message instead of a bare gateway error.
const RECONCILIATION_REQUEST_TIMEOUT_MS = 110 * 1000;

const instance = axios.create({
	baseURL: process.env.VUE_APP_RECONCILIATION_API_URL,
	timeout: RECONCILIATION_REQUEST_TIMEOUT_MS,
	// Timeouts reject with code ETIMEDOUT instead of ECONNABORTED, which axios also uses for a
	// plain browser abort - lets callers tell "took too long" apart from "request aborted".
	transitional: { clarifyTimeoutError: true },
});

instance.interceptors.request.use((config) => {
	const accessToken = store.getters.accessToken;

	if (accessToken) {
		config.headers["Authorization"] = `Bearer ${accessToken}`;
	}

	return config;
});

export default instance;
